module.exports = __webpack_public_path__ + "static/media/icon-arrow-right.1c439d19.svg";